
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/cgv",
      function () {
        return require("private-next-pages/info/cgv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/cgv"])
      });
    }
  